// TODO : split qquick payments in different components
import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useModal } from 'react-modal-hook'
import { useSelector, useDispatch } from 'react-redux'
import { Formik, Field, Form } from 'formik'
import InputError from '../../components/InputError/InputError'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../components/Modal/Modal'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoButton from '../../components/NeoButton/NeoButton'
import { NeoLoader } from '../../components/FormComponents'
import NumberFormat from 'react-number-format'
import TermsAndCondition from '../../components/TermsAndConditions/TermsAndCondition'
import AccountDisplay from '../../components/account-display/account-display'
import { useHistory, useLocation } from 'react-router-dom'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import { QuickPaySchema } from '../../schemas/transfers'
import BeneficiaryService from '../../services/beneficiary.service'
import TransferService from '../../services/transfer.service'
import { setIsAcctRefresh } from '../../store/actions/app.actions'
import {
  BUTTON_KEYS,
  QUICK_PAY_KEYS,
  VALIDATION_KEYS,
  BENEFICIARY_TRANSFER_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import config from 'custom/config/environment'
import QuickLinkService from '../../services/quick-link.service'
import { getRoleAccessKeySelector } from '../../selectors/app.selector'
const instantTransferConfig = validationConfig['quickPay']

export default function InstantTransfer() {
  const history = useHistory()
  // const [showCard, setShowCard] = useState(true)
  const [stage, setStage] = useState(1)
  const sourceAccDetails = useSelector(getCurrentAccDetailsSelector)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  // const [randomKey, setRandomKeys] = useState('')
  const [otpEnable, setOtpEnable] = useState(false)
  const [responseValues, setResponseValues] = useState({})
  const [otp, setOtp] = useState('')
  const [banks, setBanks] = useState({})
  const [bankList, setBankList] = useState([])
  const [branchList, setBranchList] = useState([])
  const [filteredBankList, setFilteredBankList] = useState([])
  const [requestType, setRequestType] = useState('')
  const accessKey = useSelector(getRoleAccessKeySelector)
  const [successResponse, setSuccessResponse] = useState({})

  // const [selectedBank, setSelectedBank] = useState('')
  const [formValues, setFormValues] = useState({
    accountType: '',
    bank: '',
    branch: '',
    accountNumber: '',
    confirmAccountNumber: '',
    amount: '',
    remarks: '',
    beneficiaryName: '',
    bankName: '',
    branchName: '',
    addBene: false,
    customRemarks: '',
    txnCurrency: '',
  })
  // const [charges, setCharges] = useState(0)
  const dispatch = useDispatch()
  // const [error, setError] = useState({})
  const { t } = useTranslation()
  const location = useLocation()
  const [data, setData] = useState({ url: '', breadCrumb: '' })
  useEffect(() => {
    getAllBankDetails()
    location.pathname.includes('/transfers') &&
      setData({ url: '/transfers', breadCrumb: 'TRANSFERS_INSTANT_TRANSFER' })
    location.pathname.includes('/accounts') &&
      setData({ url: '/accounts', breadCrumb: 'ACCOUNTS_INSTANT_TRANSFER' })
  }, [])

  const getAllBankDetails = useCallback(async () => {
    try {
      const response = await BeneficiaryService.getAllBankDetails({})
      if (response.status === 200) {
        const filteredData = response.data.reduce((items, obj) => {
          if (!items[obj['bankName']]) items[obj['bankName']] = []
          items[obj['bankName']].push(obj)
          return items
        }, {})
        const keys = Object.keys(filteredData)
        setBankList(keys)
        setFilteredBankList(filteredData)
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  const handleSelectBank = useCallback(
    async (selected) => {
      try {
        setBranchList(filteredBankList[selected])
      } catch (err) {
        console.error(err)
      }
    },
    [filteredBankList],
  )

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={confirmInstantTransfer} loading={loading} />
        )
      case 4:
        return (
          <NeoSuccess
            onClick1={async () =>
              await QuickLinkService.pdfReceipt({
                transRefNum: successResponse.referenceNo,
                refId: '',
                module: 'FUNDTRANSFER',
              })
            }
            module='DOWNLOAD_RECEIPT'
            roleKey={accessKey}
            message={message}
            linkPath={`${data.url}/quick-pay`}
          />
        )
      default:
        return renderForm()
    }
  }

  const verifyInstantTransfer = useCallback(
    async (data, { setSubmitting }) => {
      if (data.amount === '0.00' || data.amount === '.00') {
        return
      }
      setLoading(true)
      setSubmitting(true)
      let branchDetails = {}
      if (data.accountType !== 'IAT') {
        // branchDetails = branchList.filter((ele) => ele.branchDesc === data.branchName)[0]
        if (config.CLIENT_NAME !== 'NBS') {
          branchDetails = branchList.filter((ele) => ele.branchDesc === data.branchName)[0]
        } else {
          branchDetails = branchList.filter((ele) => ele.bankName === data.bankName)[0]
        }
      }
      setFormValues({ ...data, ...branchDetails })

      try {
        const reqParams = {
          transferReq: {
            fin: {
              srcAccount: sourceAccDetails.accountNo,
              srcAccBranch: sourceAccDetails.brnCode,
              srcAccCcy: sourceAccDetails.currency,
              destAccount: data.accountNumber,
              destAccBranch: branchDetails?.branchDesc || '',
              destAccCcy: '',
              destBankName: branchDetails?.bankName || '',
              destBankCountry: branchDetails.countryCode || '',
              destBankAddress: branchDetails.address,
              beneAddress: '',
              modeOfTransfer: '',
              amount: data.amount,
              txnCurrency: data.txnCurrency,
              bicCode: branchDetails.bicCode || '',
              sortCode: branchDetails?.sortCode || '',
              remarks: data.remarks,
              chargesBorneBy: '',
              txnDate: '',
            },
            nfin: {
              transferType: data.accountType,
              beneId: 0,
              scheduled: false,
              scheduledDate: data.scheduledDate || '',
              beneficiaryName: data.beneficiaryName || '',
              beneficiaryMail: data.beneEMail || '',
              beneficiaryMobile: data.beneMobileNo || '',
              addBeneficiary: data.addBene ? true : false,
              bulkTransfer: false,
            },
            cdf: {},
          },
        }

        const response = await TransferService.internalVerifyFundTransfer(reqParams)
        if (response.status === 200) {
          setOtpEnable(response.data['otpEnable'])
          setResponseValues(response.data)
          setSubmitting(false)
          setLoading(false)
          setStage(2)
        } else {
          // setError({ code: response.data.code, message: response.data.message })
          // //showModal()
        }
      } catch (err) {
        // setError(err || { code: '-', message: 'Please Contact Bank' })
        setSubmitting(false)
        setLoading(false)
        // //showModal()
      }
    },
    [banks, bankList, sourceAccDetails, branchList],
  )

  const confirmInstantTransfer = useCallback(async () => {
    setLoading(true)

    try {
      const reqParams = {
        transferReq: {
          fin: {
            srcAccount: sourceAccDetails.accountNo,
            srcAccBranch: sourceAccDetails.brnCode,
            srcAccCcy: sourceAccDetails.currency,
            destAccount: formValues.accountNumber,
            destAccBranch:
              formValues.accountType === 'IAT'
                ? responseValues['destAccountDetails'].branchCode
                : formValues?.branchDesc || '',
            destAccCcy:
              formValues.accountType === 'IAT' ? responseValues['destAccountDetails'].currency : '',
            destBankName: formValues?.bankName || '',
            destBankCountry: formValues.countryCode || '',
            destBankAddress: formValues.address,
            beneAddress: '',
            modeOfTransfer: '',
            amount: formValues.amount,
            txnCurrency: formValues.txnCurrency,
            bicCode: formValues.bicCode,
            sortCode: formValues?.sortCode || '',
            remarks: formValues.remarks,
            chargesBorneBy: '',
            txnDate: '',
          },
          nfin: {
            transferType: formValues.accountType,
            beneId: 0,
            scheduled: false,
            scheduledDate: formValues.scheduledDate || '',
            beneficiaryName:
              formValues.accountType === 'IAT'
                ? responseValues['destAccountDetails'].accountName
                : formValues.beneficiaryName || '',
            beneficiaryMail: formValues.beneEMail || '',
            beneficiaryMobile: formValues.beneMobileNo || '',
            addBeneficiary: formValues.addBene ? true : false,
            bulkTransfer: false,
          },
          cdf: {},
        },
        otp: otp || '0000',
        randomKey: responseValues.randomKey,
      }

      const response = await TransferService.confirmIATTransfer(reqParams)
      if (response.status === 200) {
        dispatch(setIsAcctRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data.message)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
    setLoading(false)
  }, [formValues, banks, otp, responseValues, sourceAccDetails])

  function renderAccountField(errors, touched, setFieldValue) {
    if (requestType === 'DDACC' || requestType === 'RTGS' || requestType === 'REGION') {
      return (
        <div>
          <NeoInput
            tabIndex='2'
            showAsterisk={instantTransferConfig['isAccountNoRequired']}
            text={t(QUICK_PAY_KEYS.ACCOUNT_NO)}
            onChange={(value) => {
              setFieldValue('accountNumber', value?.value)
            }}
            mode='password'
            name='accountNumber'
            minLength={5}
            maxLength={20}
          />
          <InputError text={errors.accountNumber} touched={touched.accountNumber} />
        </div>
      )
    }
    return (
      <div>
        <NeoInput
          tabIndex='2'
          showAsterisk={instantTransferConfig['isAccountNoRequired']}
          text={t(QUICK_PAY_KEYS.ACCOUNT_NO)}
          onChange={(value) => {
            setFieldValue('accountNumber', value?.value)
          }}
          mode='password'
          name='accountNumber'
          maxLength={config.ACC_NO_LENGTH}
        />
        <InputError text={errors.accountNumber} touched={touched.accountNumber} />
      </div>
    )
  }

  function renderConfirmAccountField(errors, touched, setFieldValue, handleChange, values) {
    if (requestType === 'DDACC' || requestType === 'RTGS' || requestType === 'REGION') {
      return (
        <div>
          <NeoInput
            tabIndex='3'
            showAsterisk={instantTransferConfig['isConfirmAccountNoRequired']}
            text={t(QUICK_PAY_KEYS.CONFIRM_ACCOUNT_NO)}
            mode='onlyNumber'
            onChange={(value) => {
              setFieldValue('confirmAccountNumber', value?.value)
            }}
            name='confirmAccountNumber'
            value={values.confirmAccountNumber}
            minLength={5}
            maxLength={20}
          />
          <InputError text={errors.confirmAccountNumber} touched={touched.confirmAccountNumber} />
        </div>
      )
    }
    return (
      <div>
        <NeoInput
          tabIndex='3'
          showAsterisk={instantTransferConfig['isConfirmAccountNoRequired']}
          text={t(QUICK_PAY_KEYS.CONFIRM_ACCOUNT_NO)}
          mode='onlyNumber'
          onChange={(value) => {
            setFieldValue('confirmAccountNumber', value?.value)
          }}
          name='confirmAccountNumber'
          value={values.confirmAccountNumber}
          maxLength={config.ACC_NO_LENGTH}
        />
        <InputError text={errors.confirmAccountNumber} touched={touched.confirmAccountNumber} />
      </div>
    )
  }
  const transferTypes = {
    IAT: t(QUICK_PAY_KEYS.INTERNAL),
    DDACC: t(QUICK_PAY_KEYS.DDACC_TRANSFER),
    RTGS: t(QUICK_PAY_KEYS.RTGS_TRANSFER),
    REGION: t(QUICK_PAY_KEYS.REGION_TRANSFER),
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(QUICK_PAY_KEYS.TITLE)}</div>
        <Formik
          initialValues={formValues}
          enableReinitialize
          validationSchema={QuickPaySchema}
          onSubmit={verifyInstantTransfer}>
          {({
            isSubmitting,
            errors,
            touched,
            handleChange,
            values,
            setFieldValue,
            setFieldTouched,
          }) => (
            <Form>
              <AccountDisplay currentAccountDetail={sourceAccDetails} />

              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(QUICK_PAY_KEYS.TRANSCTION_CURRRENCY)}
                    {instantTransferConfig['isTransactionCurrencyRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'1'}
                    as='select'
                    name='txnCurrency'
                    className='form-control'
                    onChange={(e) => {
                      handleChange(e)
                    }}>
                    <option value='' />
                    {config.TRANSACTION_CURRENCY.map((option, index) => (
                      <option value={option} key={index}>
                        {option}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.txnCurrency} touched={touched.txnCurrency} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(QUICK_PAY_KEYS.ACCOUNT_TYPE)}
                    {instantTransferConfig['isTransferTypeRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'1'}
                    as='select'
                    name='accountType'
                    className='form-control'
                    onChange={(e) => {
                      setRequestType(e.target.value)
                      setFieldValue('accountNumber', '')
                      setFieldValue('confirmAccountNumber', '')
                      handleChange(e)
                    }}>
                    <option value='' />
                    {config.TRANSFER_TYPES.map((option, index) => (
                      <option value={option} key={index}>
                        {transferTypes[option]}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.accountType} touched={touched.accountType} />
                </div>
                {/* <div className='form-group col-12'>
                  <NeoInput
                    showAsterisk={instantTransferConfig['isTransferTypeRequired']}
                    mode='select'
                    text={t(QUICK_PAY_KEYS.ACCOUNT_TYPE)}
                    name='accountType'
                    onChange={(e) => {
                      setRequestType(e.target.value)
                      setFieldValue('accountNumber', '')
                      setFieldValue('confirmAccountNumber', '')
                      handleChange(e)
                    }}
                    onBlur={() => setFieldTouched('accountType', true)}
                    keyValue={null}
                    list={transferTypes[config.TRANSFER_TYPES]}
                  />
                  <InputError text={errors.accountType} touched={touched.accountType} />
                </div> */}
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  {renderAccountField(errors, touched, setFieldValue)}
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  {renderConfirmAccountField(errors, touched, setFieldValue, handleChange, values)}
                </div>
              </div>

              {(values.accountType === 'DDACC' ||
                values.accountType === 'RTGS' ||
                requestType === 'REGION') && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={instantTransferConfig['isBeneNameRequired']}
                      text={t(QUICK_PAY_KEYS.BENEFICIARY_NAME)}
                      onChange={handleChange}
                      name='beneficiaryName'
                      value={values.beneficiaryName}
                      minLength={2}
                      maxLength={32}
                      onKeyPress={(event) => {
                        if (
                          !(event.charCode >= 65 && event.charCode <= 90) &&
                          !(event.charCode >= 97 && event.charCode <= 122) &&
                          event.charCode !== 32
                        ) {
                          event.preventDefault()
                        }
                      }}
                    />
                    <InputError text={errors.beneficiaryName} touched={touched.beneficiaryName} />
                  </div>
                </div>
              )}

              {(values.accountType === 'DDACC' ||
                values.accountType === 'RTGS' ||
                requestType === 'REGION') && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      mode='select'
                      showAsterisk={instantTransferConfig['isBeneBankRequired']}
                      text={t(QUICK_PAY_KEYS.SELECT_BANK)}
                      name='bankName'
                      onChange={(e) => {
                        handleChange(e)
                        handleSelectBank(e.target.value)
                        setFieldValue('bankName', e.target.value)
                        setFieldValue('branchName', '')
                      }}
                      list={bankList}
                    />
                    <InputError text={errors.bankName} touched={touched.bankName} />
                  </div>

                  <div className='form-group col-12'>
                    {config.CLIENT_NAME !== 'NBS' ? (
                      <NeoInput
                        tabIndex='6'
                        mode='select'
                        showAsterisk={instantTransferConfig['isBranchRequired']}
                        text={t(QUICK_PAY_KEYS.SELECT_BRANCH)}
                        name='branchName'
                        onChange={(e) => {
                          handleChange(e)
                          setFieldValue('branchName', e.target.value)
                        }}
                        list={branchList}
                        keyValue='branchDesc'
                      />
                    ) : (
                      <NeoInput
                        tabIndex='6'
                        showAsterisk={instantTransferConfig['isBranchRequired']}
                        text={t(QUICK_PAY_KEYS.SELECT_BRANCH)}
                        name='branchName'
                        value={values.branchName}
                        onChange={handleChange}
                      />
                    )}
                    <InputError text={errors.branchName} touched={touched.branchName} />
                  </div>
                </div>
              )}

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='7'
                    mode='amount'
                    showAsterisk={instantTransferConfig['isAmountRequired']}
                    text={t(QUICK_PAY_KEYS.AMOUNT)}
                    onChange={(values) => {
                      setFieldValue('amount', values.value)
                    }}
                    name='txnAmount'
                  />
                  <InputError text={errors.amount} touched={touched.amount} />
                  <InputError
                    text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                    touched={values.amount === '0.00' || values.amount === '.00'}
                  />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='8'
                    showAsterisk={instantTransferConfig['isRemarksRequired']}
                    text={t(QUICK_PAY_KEYS.REMARKS)}
                    onChange={handleChange}
                    value={values.remarks}
                    name='remarks'
                  />
                  <InputError text={errors.remarks} touched={touched.remarks} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12 text-right'>
                  <div className='form-check'>
                    <Field
                      tabIndex={'9'}
                      as='input'
                      type='checkbox'
                      className='form-check-input'
                      name='addBene'
                    />
                    <label className='form-check-label control-label' htmlFor='gridCheck'>
                      {t(QUICK_PAY_KEYS.ADD_BENEFICIARY)}
                    </label>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  {loading ? (
                    renderLoading()
                  ) : (
                    <NeoButton
                      tabIndex='10'
                      type='submit'
                      disabled={loading}
                      text={t(BUTTON_KEYS.SUBMIT)}
                      mode='newDesign'
                    />
                  )}
                </div>
              </div>

              <div className='back-cancel-btn-container'>
                <button
                  tabIndex={'12'}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  onClick={() => history.push(data.url)}>
                  {t(BUTTON_KEYS.CANCEL)}
                </button>
              </div>

              {(values.accountType === 'DDACC' ||
                values.accountType === 'RTGS' ||
                requestType === 'REGION') &&
                config.CLIENT_NAME !== 'NBS' && (
                  <div className='row'>
                    <div className='form-group col-12'>
                      <p className='small font-weight-600'>{t(QUICK_PAY_KEYS.NOTE)}</p>
                    </div>
                  </div>
                )}
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirm() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(QUICK_PAY_KEYS.CONFIRM_TRANSFER)}</h3>

        <AccountDisplay currentAccountDetail={sourceAccDetails} />

        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.TRANSFER_MODE)}</h6>
          <h6 className='value'>{formValues.accountType}</h6>
        </div>

        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.TRANSCTION_CURRRENCY)}</h6>
          <h6 className='value'>{formValues.txnCurrency}</h6>
        </div>

        {formValues.accountType !== 'IAT' && (
          <div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BANK)}</h6>
              <h6 className='value'>{formValues.bankName}</h6>
            </div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BRANCH)}</h6>
              <h6 className='value'>{formValues.branchName}</h6>
            </div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BIC_CODE)}</h6>
              <h6 className='value'>{formValues.bicCode}</h6>
            </div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.SORT_CODE)}</h6>
              <h6 className='value'>{formValues.sortCode}</h6>
            </div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BENEFICIARY_NAME)}</h6>
              <h6 className='value'>{formValues.beneficiaryName}</h6>
            </div>
          </div>
        )}

        {formValues.accountType === 'IAT' && (
          <div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BENEFICIARY_NAME)}</h6>
              <h6 className='value'>{responseValues['destAccountDetails'].accountName}</h6>
            </div>
          </div>
        )}

        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.BENEFICIARY_ACCOUNT_NO)}</h6>
          <h6 className='value'>{formValues.accountNumber}</h6>
        </div>

        {formValues.accountType === 'IAT' && (
          <div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BENEFICIARY_BRANCH)} </h6>
              <h6 className='value'>{responseValues['destAccountDetails'].branchCode}</h6>
            </div>
            <div>
              <h6 className='label'>{t(QUICK_PAY_KEYS.BENEFICIARY_CURRENCY)} </h6>
              <h6 className='value'>{responseValues['destAccountDetails'].currency}</h6>
            </div>
          </div>
        )}

        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.AMOUNT)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.CHARGES)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={responseValues?.charges || 0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        {/* <div>
          <h6 className='label'>Transfer Charges</h6>
          <h6 className='value'>{responseValues.charges || 0}</h6>
        </div> */}
        {/* <div>
          <h6 className='label'>Debit Amount</h6>
          <h6 className='value'>
            <NumberFormat
              value={responseValues.debitAmount || 0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
            />
          </h6>
        </div> */}
        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.REMARKS)}</h6>
          <h6 className='value'>
            {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
          </h6>
        </div>

        <div>
          <h6 className='label'>{t(QUICK_PAY_KEYS.ADD_AS_BENEFICIARY)}</h6>
          <h6 className='value'>{formValues.addBene ? 'Yes' : 'No'}</h6>
        </div>
        <div>
          <TermsAndCondition module='FUNDTRANSFER' />
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              text={t(BUTTON_KEYS.CONFIRM)}
              mode='newDesign'
              onClick={async () => {
                otpEnable ? setStage(3) : await confirmInstantTransfer()
              }}></NeoButton>
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
